import React from 'react'
import { Button } from '@klear/ui/components/button'

export type WizardNavRowProps = {
  isFirstStep: boolean
  isLastStep: boolean
  onPrev: () => void
  onNext: () => void
  onSubmit?: () => void
  cancelOnFirstStep?: boolean
  disabled?: boolean
  nextDisabled?: boolean
  submitDisabled?: boolean
  nextLabel?: React.ReactNode
  nextIcon?: React.ReactNode
  submitLabel?: React.ReactNode
  submitIcon?: React.ReactNode
  prevLabel?: React.ReactNode
  className?: string
}

export function WizardNavRow({
  isFirstStep,
  isLastStep,
  onPrev,
  onNext,
  onSubmit,
  cancelOnFirstStep = false,
  disabled = false,
  nextDisabled,
  submitDisabled,
  nextLabel = 'Next',
  nextIcon,
  submitLabel = 'Save',
  submitIcon,
  prevLabel,
  className = 'mt-4 flex justify-between gap-2'
}: WizardNavRowProps) {
  const showCancel = isFirstStep && cancelOnFirstStep
  const resolvedPrevLabel = prevLabel ?? (showCancel ? 'Cancel' : 'Previous')
  const prevDisabled = disabled || (isFirstStep && !cancelOnFirstStep)

  return (
    <div className={className}>
      <Button type="button" variant="outline" onClick={onPrev} disabled={prevDisabled}>
        {resolvedPrevLabel}
      </Button>
      {isLastStep ? (
        <Button type="button" disabled={disabled || submitDisabled === true} onClick={onSubmit}>
          {submitIcon}
          {submitLabel}
        </Button>
      ) : (
        <Button type="button" onClick={onNext} disabled={disabled || nextDisabled === true}>
          {nextIcon}
          {nextLabel}
        </Button>
      )}
    </div>
  )
}
